
const CustomIcon = ({icon}) => {
  return (
    <div className='table-cell align-top pr2' style={{paddingTop: '4px'}}>
      <img src={icon} role='presentation' style={{height: '32px', width: '32px', marginBottom: '1px'}} className='rounded'/>
    </div>
  );
};

export default CustomIcon;
